import React from 'react';
import { Lock } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

interface PremiumBadgeProps {
  /** Use 'inline' to fit inside a button label, 'corner' for an absolute-positioned overlay */
  variant?: 'inline' | 'corner';
}

/**
 * Small lock icon signaling "this action requires a higher plan".
 * Pairs with `UpgradeNoticeSnackbar` — the badge is the at-rest cue, the
 * snackbar is the on-click explanation.
 */
export const PremiumBadge: React.FC<PremiumBadgeProps> = ({ variant = 'inline' }) => {
  const { t } = useTranslation();
  const label = t('PLANS.PREMIUM_BADGE', 'Premium');

  return (
    <span
      aria-label={label}
      className={cn(
        // A circle, deliberately: it reads as a stamp on the control rather
        // than as one more square chip in a page full of them.
        'inline-flex size-[18px] shrink-0 items-center justify-center rounded-full bg-primary text-primary-foreground',
        variant === 'corner' ? 'absolute -top-1.5 -end-1.5' : 'ms-1.5',
      )}
    >
      <Lock className="size-[11px]" />
    </span>
  );
};

export default PremiumBadge;
